import { Component } from "react";

// The chat panel never takes the app down with it: a render error inside it
// (an unexpected card from the server, a restored chat it can't show) hides
// the panel and leaves every screen working. React has no hook for this.
export default class AgentChatBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("[agent chat] hidden after a render error:", error);
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
